import React from 'react';
import './styles.css';

export default class WhatWeDo extends React.Component {
  render() {
    return (
      <div className="invest-inner wwd-container">
        <p className="invest-slogan">About us</p>
        <ul className="invest-professions">
          <li>Therapy Academy is an online resource for therapists and those concerned with the mental health field to take CPD workshops and further their expertise. We provide an interactive learning experience where the participant takes their chosen workshop / course online through our easy to use website. We deliver courses that are suitable for online learning and are recognised by governing bodies for reaccreditation. All of our online workshops / courses are provided by accredited mental health practitioners who are experts in their field.</li>
        </ul>
        <ul className="invest-professions">
          <li>We hope that Therapy Academy will make it easy and enjoyable for all therapists in different spheres to access CPD online, to manage their own learning and improve their practice.</li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/aboutUs/WhatWeDo.jsx